export type ReviewPriority = 'P0' | 'P1' | 'P2' | 'P3';

export const PRIORITY_SEVERITY_THRESHOLDS = { P0: 9, P1: 7, P2: 4 } as const;

export const PRIORITY_ORDER: Record<ReviewPriority, number> = {
  P0: 0,
  P1: 1,
  P2: 2,
  P3: 3,
};

/**
 * Maps a severity score (0-10) to a priority level (P0-P3).
 */
export function severityToPriority(severity: number): ReviewPriority {
  if (severity >= PRIORITY_SEVERITY_THRESHOLDS.P0) {
    return 'P0';
  }
  if (severity >= PRIORITY_SEVERITY_THRESHOLDS.P1) {
    return 'P1';
  }
  if (severity >= PRIORITY_SEVERITY_THRESHOLDS.P2) {
    return 'P2';
  }
  return 'P3';
}
